var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.78,
    height: 16.434,
    viewBox: "0 0 21.78 16.434",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Flag-active",
    d: "M14.57,0H1.933A1.93,1.93,0,0,0,0,1.849V20.543a1.433,1.433,0,0,0,.244.831.945.945,0,0,0,.78.406,1.409,1.409,0,0,0,.9-.377l5.654-4.8a1.12,1.12,0,0,1,1.372,0l5.635,4.8a1.36,1.36,0,0,0,.874.378c.5,0,.979-.383.979-1.237V1.849A1.869,1.869,0,0,0,14.57,0Z",
    transform: "translate(0 16.434) rotate(-90)",
    fill: "#fa6450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagActive);
export default __webpack_public_path__ + "static/media/Flag-active.af7f1b68c469efd73007637dd236e9a0.svg";
export { ForwardRef as ReactComponent };